import { FC } from 'react';
import { Modal } from 'react-bootstrap';
import { useTranslate } from 'hooks/useTranslate';

import CommentsCharCounter from 'modules/_shared/components/CommentsCharCounter';
import { useAddPartnerNoteModal } from '../context/AddPartnerNoteModalContext';

const AddPartnerNoteModalBody: FC = () => {
  const { t } = useTranslate();

  const MAX_COMMENT_LENGTH = 1000;
  const TEXT_AREA_HEIGHT = '150px';

  const { data, actions } = useAddPartnerNoteModal();
  return (
    <>
      <Modal.Body>
        <div className="nk-modal">
          <div className="form-group">
            <label className="form-label" htmlFor="annotation-text">
              {t('Annotation')}
            </label>
            <div className="form-control-wrap">
              <div className="form-editor-custom">
                <textarea
                  id="annotation-text"
                  maxLength={MAX_COMMENT_LENGTH}
                  style={{ height: TEXT_AREA_HEIGHT }}
                  className="form-control form-control-lg no-resize"
                  value={data.text}
                  onChange={actions.handleChangeText}
                />
              </div>
            </div>

            <div className="form-note d-flex justify-content-between">
              <CommentsCharCounter
                comments={data.text}
                maxLength={MAX_COMMENT_LENGTH}
              />
            </div>
          </div>
        </div>
      </Modal.Body>
    </>
  );
};

export default AddPartnerNoteModalBody;
